import { Button, Stack, Typography } from '@mui/material';
import React, {useState, useEffect} from 'react'

const CountdownTimer = ({
    hoursMinSecs, 
    onRequestVerificationCode 
}) => {
   
    const { hours = 0, minutes = 0, seconds = 60 } = hoursMinSecs;
    const [[hrs, mins, secs], setTime] = useState([hours, minutes, seconds]);


    const [reset_flag, setResetFlag] = useState(false)

    const tick = () => {
   
        if (hrs === 0 && mins === 0 && secs === 0) {
            setResetFlag(true)
        }
            //reset()
        else if (mins === 0 && secs === 0) {
            setTime([hrs - 1, 59, 59]);
        } else if (secs === 0) {
            setTime([hrs, mins - 1, 59]);
        } else {
            setTime([hrs, mins, secs - 1]);
        }
    };


    const reset = () => {
        setResetFlag(false)
        onRequestVerificationCode()
        setTime([parseInt(hours), parseInt(minutes), parseInt(seconds)])
    }

    
    useEffect(() => {
        const timerId = setInterval(() => tick(), 1000);
        return () => clearInterval(timerId);
    });

    
    return (
        <div>
            
            {reset_flag 
            ? (
                <Button variant='outlined' color='primary' 
                    style={{borderRadius:24, textTransform:'none', fontSize:'1.2rem'}} 
                    onClick={reset}
                >
                    Reenviar código
                </Button>
            ) : (
                <Stack alignItems='center'>
                    <Typography >Volver a enviar mensaje en</Typography>
                    <Typography variant='subtitle1' color='primary'>
                        {secs.toString().padStart(2, '0')} segundos 
                    </Typography>
                </Stack>
            )
            
            }
        </div>
    );
}

export default CountdownTimer;


//con horas
/* <p>{`${hrs.toString().padStart(2, '0')}:${mins
            .toString()
            .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`}</p> */